module.exports = __webpack_public_path__ + "img/title-4.4b5045c3.png";